<template>
  <div>
    <div style="width:100%;height:100%">
      <h1 class="chart-top-title">药品进销管理<span @click="dialogVisible = true" class="chart-modal-flag"><i class="el-icon-view"></i></span></h1>
      <div class="chart-y-name">
        <span>流入</span>
        <span class="chart-y-name-r">流出</span>
      </div>
      <div class="chart-wrapper" ref="chart" style="height:324px;width:100%"></div>
      <p class="remarkes">备注：2012年～2017年全国药品商业企业销售额和进货额对比分析（千万）</p>
    </div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <div class="modalContent">
        <img src="../../../static/imgs/industrialEnterprises.jpg" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { vueBus } from '../../assets/js/common/vueBus'
export default {
  props: ['echartsData'],
  data() {
    return {
      anima: '',
      axisLineColor: '#808080',
      splitLineColor: '#AEAEAF',
      dataArr: [
        [-49469.21, -57709.41, -66499.77, -73546.95, -81423.94, -88611.96],
        [111744.32, 130357.83, 150214.08, 166132.7, 183925.77, 200162.54]
      ],
      color: this.$chartColor || ['#08A7DF', '#8ABE32'],
      axisLabelColor: '#ccd6e0',
      axisLineColor: '#809ab1',
      yData: ['2012', '2013', '2014', '2015', '2016', '2017'],
      seriesName: ['流入', '流出'],
      dialogVisible: false,
      mask: false
    }
  },
  watch: {
    echartsData: {
      handler: function(val, oldVal) {
        this.initChart()
      },
      deep: true //增加deep 观察对象的子对象变化
    },
    anima: {
      handler: function(val, oldVal) {
        if (val == 'animateStart') {
          this.myChart = this.$echarts.init(this.$refs.chart)
          this.initChart()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      vueBus.$on('imgOnload', v => {
        me.anima = v
      })
    })
  },
  methods: {
    initChart() {
      let series = []
      this.dataArr.map((item, index) => {
        let colorItem = ''
        if (index === 0) {
          colorItem = new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              offset: 1,
              color: 'rgba(8,167,222,.2)'
            },
            {
              offset: 0,
              color: '#000000'
            }
          ])
        } else {
          colorItem = new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
            {
              offset: 1,
              color: 'rgba(138,190,50,.2)'
            },
            {
              offset: 0,
              color: '#000000'
            }
          ])
        }
        series.push({
          name: this.seriesName[index],
          type: 'bar',
          barWidth: 15,
          xAxisIndex: index,
          yAxisIndex: index,
          itemStyle: {
            borderColor: this.color[index],
            borderWidth: 2,
            color: colorItem
          },
          data: item,
          animationDelay: function(idx) {
            return idx * 100
          },
          animationDuration: function(idx) {
            return idx * 200
          }
        })
      })
      let option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params){
            return params[0].name + '<br/>' + params[0].seriesName + '：' + Math.abs(params[0].value)
          }
        },
        legend: {
          show: false
        },
        grid: [{ x: '10%', y: 30, width: '40%', height: '75%' }, { x: '50%', y2: 51, width: '40%', height: '75%' }],
        xAxis: [
          {
            gridIndex: 0,
            type: 'value',
            // name: '单位：亿元',
            min: -110000,
            max: 0,
            nameTextStyle: {
              color: this.axisLabelColor,
              fontSize: 16
            },

            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: this.axisLineColor
              }
            },
            axisLabel: {
              color: this.axisLabelColor,
              formatter: function(params) {
                if (params < 0) {
                  return Math.abs(params)
                } else return params
              }
            },
            axisLine: {
              lineStyle: {
                color: this.axisLineColor
              }
            }
          },
          {
            gridIndex: 1,
            type: 'value',
            // name: '单位：亿元',
            min: 0,
            max: 200000,
            nameTextStyle: {
              color: this.axisLabelColor,
              fontSize: 16
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: this.axisLineColor
              }
            },
            axisLabel: {
              color: this.axisLabelColor,
              formatter: function(params) {
                if (params < 0) {
                  return Math.abs(params)
                } else return params
              }
            },
            axisLine: {
              lineStyle: {
                color: this.axisLineColor
              }
            }
          }
        ],
        yAxis: [
          {
            gridIndex: 0,
            type: 'category',
            name: '',
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              },
              color: this.axisLabelColor
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.axisLineColor
              }
            },
            axisTick: { show: false },
            data: this.yData
          },
          {
            gridIndex: 1,
            type: 'category',
            name: '',
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              },
              color: this.axisLabelColor
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.axisLineColor
              }
            },
            axisTick: { show: false },
            data: this.yData
          }
        ],
        series: series,
        animationEasing: 'elasticOut'
      }
      this.myChart.on('click', params => {
        this.$emit('handleCharts', params.name)
      })
      this.myChart.setOption(option)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.chart-y-name {
  width: 100%;
  height: 50px;
  line-height: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  span {
    float: left;
    padding: 0 50px;
    font-size: 34px;
  }
  span.chart-y-name-r {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/transverseDoubleBar.vue